export default function (initRequest,baseUrl) {
    return {
        getHotelDetail: initRequest.des("获取酒店详情").get("/api/Hotel/GetHotelDetail"),
        getHotelStaticData: initRequest.des("获取酒店详情静态数据").get("/api/Hotel/GetHotelStaticData"),
        getComments: initRequest.des("酒店点评列表").get("/api/Comment/GetComments"),
        getQuestions: initRequest.des("酒店问答").get("/api/Comment/GetQuestions"),
        getHotelPeriphery: initRequest.des("周边商户 MerchantType：1交通设施 2景点娱乐 3餐饮 4城市指南").get("/api/Hotel/GetHotelPeriphery"),
        getHotelDescription: initRequest.des("获取酒店房型详情").get("/api/Hotel/GetHotelDescription"),
    }
}